<template>
  <div ref="streamInfo" id="app-live-stream-info" :class="isLiveInfoOpen ? 'expanded' : ''">
    <div class="stream-info">
      <div ref="streamScroll" class="stream-info__inner">
        <AppLiveStreamInfoCard :channel="stream1" label="1"/>
        <AppLiveStreamInfoCard :channel="stream2" label="2"/>
        <AppLiveStreamInfoCard :channel="stream3" label="3"/>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapState} from 'vuex';
import AppLiveStreamInfoCard from "@/components/header/AppLiveStreamInfoCard.vue";

export default {
  name: 'AppLiveStreamInfo',
  components: {AppLiveStreamInfoCard},
  data: () => ({
    isMobile: false
  }),
  computed: {
    ...mapGetters({
      playingNowTitle1: 'getLiveStreamTitle1',
      playingNowTitle2: 'getLiveStreamTitle2',
      playingNowTitle3: 'getLiveStreamTitle3',
      playingNextTitle1: 'getLiveStreamNextTitle1',
      playingNextTitle2: 'getLiveStreamNextTitle2',
      playingNextTitle3: 'getLiveStreamNextTitle3',
      stream1: 'getLiveStreamInfoDataOne',
      stream2: 'getLiveStreamInfoDataTwo',
      stream3: 'getLiveStreamInfoDataThree'
    }),
    ...mapState({
      isLiveInfoOpen: state => state.liveStreamInfoState,
    })
  },
  watch: {
    '$route.name'() {
      this.$store.commit('setLiveStreamInfoState', false);
    },
    isLiveInfoOpen(value) {
      if (value && this.isMobile) {
        document.documentElement.classList.add('no-scroll');
        const timeout = setTimeout(() => {
          this.$refs.streamInfo.scrollTo({
            left: 0,
            top: 0,
            behavior: 'smooth'
          });
          clearTimeout(timeout)
        }, 250);
      } else {
        document.documentElement.classList.remove('no-scroll');
      }
    }
  },
  mounted() {
    this.checkDeviceViewPort();
  },
  methods: {
    checkDeviceViewPort() {
      let mql = window.matchMedia('(max-width: 768px)');
      if (mql.matches) this.isMobile = true;
      else this.isMobile = false;
    },
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_app-live-streaming-info.scss';
</style>
